<div class="upload-container">
  <div class="upload-header-section border-bottom mb-4">
    <h4>Import file</h4>
  </div>
  <ng-container>
    <label for="{{ (initiateFileUploading || isUploadingError) ? 'file-upload' : ''}}" class="custom-file-upload">

      <ng-container *ngIf="initiateFileUploading">
        <span>{{isUploadAnotherFile ? 'UPLOAD ANOTHER FILE' : 'UPLOAD FILE'}} <img src="assets/img/upload-icon.svg"
            alt=""></span>
        <small>Please select a file with max size upto {{maxFileSizeInMb}}MB</small>
      </ng-container>

      <ng-container *ngIf="isUploading">
        <div class="progress-percentage">{{uploadPercentage}}%</div>
        <div class="progress">
          <mat-progress-bar mode="determinate" [value]="uploadPercentage"></mat-progress-bar>
        </div>
        <small>File Uploading...</small>
      </ng-container>

      <ng-container *ngIf="isUploadingPreview">
        <div class="d-flex justify-content-start flex-wrap">
          <div class="file-box">
            <img src="assets/img/presentations-img-1.png" alt="">
            <div class="d-flex justify-content-between file-box-bottom">
              <div class="file-name">
                <img src="assets/img/presentations-icon.svg" alt="" class="mr-2"> Classwork.ppt
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isUploadingSuccess">
        <div class="progress-percentage">UPLOAD COMPLETED! <img src="assets/img/upload-success-icon.svg" alt=""
            class="ml-2" /></div>
        <div class="progress">
          <div class="color-success"></div>
        </div>
      </ng-container>

      <ng-container *ngIf="isUploadingError">
        <small class="error-txt">Oops! Upload Failed</small>
        <img src="assets/img/error-icon.svg" alt="" class="my-2">
        <small class="mb-4 mt-4"> {{errorMsg}} <br> {{ getUploadErrorInfoText() }} </small>
        <span>UPLOAD ANOTHER FILE <img src="assets/img/upload-icon.svg" alt=""></span>
      </ng-container>

    </label>
    <input id="file-upload" type="file" (change)="onDocumentChanged($event)" />
  </ng-container>

  <div class="d-flex justify-content-end upload-bottom-section mt-4">
    <button class="btn btn-outline-secondary mr-4" [disabled]="isApiInProgress"
      (click)="cancelUploading()">Cancel</button>
    <button class="btn btn-secondary upload-btn" [ngClass]="{'api-progress': isApiInProgress}"
      [disabled]="!isUploadingSuccess || isApiInProgress" (click)="uploadDocument()">
      SAVE
      <img *ngIf="isApiInProgress" src="/assets/img/loaders/three-dots.svg" alt="loaders" />
    </button>
  </div>
</div>